import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';
import Introduction from './components/Introduction';
import RegisterLossAdjustersForm from '../../../components/forms/RegisterLossAdjustersForm';

const RegisterLossAdjustersTrainingRoot = styled('div')(({ theme }) => ({}));

const RegisterLossAdjustersTraining = () => {
    return (
        <Fade in={true}>
            <RegisterLossAdjustersTrainingRoot>
                <Introduction />

                <RegisterLossAdjustersForm />
            </RegisterLossAdjustersTrainingRoot>
        </Fade>
    );
};

export default RegisterLossAdjustersTraining;
